// src/api.js
import axios from "axios";

// Normalise la base URL (enlève les slashs finaux et un /api éventuel)
const RAW = (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) || process.env.REACT_APP_API_URL || "";
const BASE_URL = RAW.replace(/\/+$/, "").replace(/\/api$/i, "");

const API = axios.create({
  baseURL: BASE_URL,     // ex: https://backend-ft0c.onrender.com
  withCredentials: true, // cookies cross-site
});

// Ajoute l’Authorization si un token est stocké
API.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export { BASE_URL };
export default API;